import {
  buildSubdomain as ccBuildSubdomain,
  buildUrl as ccBuildUrl,
} from "@planningcenter/cc-url"

let serverOriginResolver: () => string | undefined = () => undefined

export function setServerOriginResolver(resolver: () => string | undefined) {
  serverOriginResolver = resolver
}

function currentOrigin(): string {
  if (typeof document === "undefined") return serverOriginResolver() ?? ""
  return window.location.origin
}

export function buildUrl(pathname: string, origin: string = currentOrigin()) {
  return ccBuildUrl(pathname, origin)
}

export function buildSubdomain(
  subdomain: string = "",
  origin: string = currentOrigin(),
) {
  return ccBuildSubdomain(subdomain, origin)
}
